module.exports = __webpack_public_path__ + "img/link-pocket-mobile_jp.091fab2.jpg";